
<template>
  <div class="pt-3">
    <nav class="navbar py-0 pr-4 mx-4 shadow rounded" style="background-color: rgb(61, 62, 64) !important;">
      <span class="navbarUsername">{{ username }} ({{ user.email }})</span>
      <ul class="navbar-nav d-none flex-row ml-auto d-md-flex align-items-center justify-content-end my-3">
      <!--   <li class="ml-4">
          <a href="/kilit" title="Kilitle"><i class="fas fa-lock" style="color: #e4e5e6"></i></a>
        </li> -->
        <li class="ml-4" @click="logoutAction">
          <a href="#" title="Çıkış Yap"><i class="fas fa-sign-out-alt" style="color: #e4e5e6"></i></a>
        </li>
      </ul>
      <b-modal :title="currentAnnounce.title" ref="announceModal">
        <p v-html="currentAnnounce.description"></p>
        <p class="text-right">
          {{ currentAnnounce.created_at}}
        </p>
        <template v-slot:modal-footer>
          <b-button @click="$refs.announceModal.hide()">Kapat</b-button>
        </template>
      </b-modal>
    </nav>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import language from '../languages/index'
import request from "../request";
import i18next from 'i18next';
export default {
  data() {
    return {
  
      languages:[{
        label:"Türkçe",
        val:"tr",
        flag:'tr'
      },{
        label:"Almanca",
        val:"ger",
        flag:'de'
      }],
      announces:[],
      currentAnnounce:{},
      activeNotifications: false,
      showMenu: false,
      searchQuery: '',
      request,
      notifications: [],
    };
  },
  mounted(){
    this.getAnnounces().then(res=>this.announces=res.data);
 
  },
  computed: {
    ...mapGetters(['user', 'smsBalance','announcesGetter']),
    currentFlag(){
      return this.languages.find(lang=>lang.val==language.language).flag
      // return
    },
    logoUrl() {
      return this.user && this.user.company.logo_url ? this.user.company.logo_url : ''
    },
    username() {
      return this.user ? this.user.name : ''
    },
  },
  methods: {
    ...mapActions(['logout','getAnnounces']),
    navigateToDetail(id) {
      window.location.href = `/bildirim-detayi/${id}`;
    },
    changeLanguage(val){
      localStorage.setItem('lang',val)
      location.reload()
    },
    logoutAction() {
      this.logout().then(() => {
        this.$router.go({name: 'login'});
      })
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>

<style Scoped>
  .navbarUsername{
    font-weight: 600;
    font-size: 18px;
    color: #fff;
  }

  .dropdown-menu{
    border-radius: 0.3rem !important;
  }

  .headerNotification .card-header {
    background-color: #405189 !important;
  }

  .headerNotification .nav-link{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35.5px !important;
    font-size: 13px !important;
    font-weight: 500;
    padding: 0 15px;
  }

  .headerNotification .nav-link:not(.active) {
    color: #ffffff98;
    border-color: none;
    transition: 0.2s;

  }

  .headerNotification .nav-link.active {
    background-color: #fff !important;
    border-color: #fff !important;
    color: rgb(64, 81, 137) !important
  }

  .headerNotification .card-header{
    border-radius: 0 !important;
  }

  .notCont{
    border-radius: 0.3rem !important;
    transition: 0.2s;
    padding: 4px;
  }

  .notCont:hover{
    background-color: #7795f769
  }


</style>
